import { render, staticRenderFns } from "./layer-add-update-notice.vue?vue&type=template&id=ae53b95a&scoped=true&"
import script from "./layer-add-update-notice.vue?vue&type=script&lang=js&"
export * from "./layer-add-update-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae53b95a",
  null
  
)

export default component.exports